export default __webpack_public_path__ + "static/media/Coastal.5870f9ac.jpg";